import { useMutation, useQueryClient } from '@tanstack/react-query';
import { massForceDeleteSliders } from '../../api/apiSliders';
import toast from 'react-hot-toast';

export const useMassForceDeleteSliders = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: massForceDeleteSliders,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['sliders'] });
            toast.success(data.message || 'Sliders permanently deleted successfully');
        },
        onError: (error) => {
            const errorMessage = error.response?.data?.message || 'Failed to permanently delete sliders';
            toast.error(errorMessage);
        },
    });
};